import { useSyncExternalStore } from 'react';
import { Alert } from '../../atoms/Alert/Alert';
import { Button } from '../../atoms/Button/Button';
import { useTranslation } from '../../../i18n/useTranslation';
import { ACCOUNT_SETTINGS_PATH, getTermsState, requestTermsDialog, subscribeTermsState } from '../../../lib/termsStatus';
import './TermsReadOnlyNotice.css';

/**
 * Shown above the page content while the account is read-only because the
 * new terms of service are not accepted (lib/termsStatus: set from the legal
 * status or a 403 TERMS_ACCEPTANCE_REQUIRED). Offers the terms dialog again
 * and points to the data export and account deletion in Settings. Renders
 * nothing otherwise.
 */
export function TermsReadOnlyNotice() {
  const { t } = useTranslation();
  const { readOnly } = useSyncExternalStore(subscribeTermsState, getTermsState, getTermsState);

  if (!readOnly) return null;

  return (
    <Alert
      tone="warning"
      live="polite"
      title={t('legal.termsConsent.readOnlyTitle')}
      className="rg-terms-notice"
      data-testid="terms-read-only-notice"
      action={
        <div className="rg-terms-notice__actions">
          <Button variant="primary" size="sm" onClick={requestTermsDialog}>
            {t('legal.termsConsent.review')}
          </Button>
          <a className="rg-terms-notice__link" href={ACCOUNT_SETTINGS_PATH}>
            {t('legal.termsConsent.exportOrDelete')}
          </a>
        </div>
      }
    >
      {t('legal.termsConsent.readOnlyMessage')}
    </Alert>
  );
}

export default TermsReadOnlyNotice;
